import {AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatSelectModule } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { provideNativeDateAdapter } from '@angular/material/core'
import { Player } from '../../../../core/models/player.model'
import { PlayerService } from '../../../../core/services/player.service'
import { Router, RouterModule } from '@angular/router'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { CommonModule } from '@angular/common'
import { compareTwoStrings } from 'string-similarity'
import { MatIconModule } from '@angular/material/icon'
import { Team } from 'src/app/core/models/team.model'

type SearchResult = (Player & { isTeam?: false }) | (Team & { isTeam: true })

@Component({
  selector: 'db-search',
  standalone: true,
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    CommonModule,
    MatAutocompleteModule,
    RouterModule,
    MatIconModule
  ],
  templateUrl: './db-search.component.html',
  styleUrl: './db-search.component.css'
})
export class DBSearchComponent {
  filteredResults:SearchResult[] = []
  @ViewChild('playerInput') playerInput: any

  constructor(
    public service: PlayerService,
    private router: Router
  ){}

  filter(inputElement: HTMLInputElement) {
    const inputValue = inputElement.value.toLowerCase()
    if(inputValue.length > 2)
    this.service.fetchSearchResults(inputValue).subscribe(results=>{
      this.filteredResults = results as SearchResult[]
    })
  }

  onPlayerSelected(event: any) {
    const item = event.option.value as SearchResult
    this.filteredResults = []
    this.playerInput.nativeElement.value = ''
    if (item.isTeam) {
      this.router.navigate(['/db/teams', item._id])
    } else {
      this.router.navigate(['/db/players', item._id])
    }
  }

  displayFn(value: Player) {
    return value ? value.name : ""
  }

  get players() {
    return this.filteredResults.filter(i => !i.isTeam)
  }

  get teams() {
    return this.filteredResults.filter(i => i.isTeam)
  }
}